export default __webpack_public_path__ + "static/media/Hyatt.e7e33c42.png";